import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  softCreditCheckTitle: {
    id: "funding-application: soft credit check",
    defaultMessage: "Soft credit check",
  },
  firstNameLabel: {
    id: "funding-application: first name input label",
    defaultMessage: "First name",
  },
  firstNameError: {
    id: "funding-application: first name required",
    defaultMessage: "Enter your first name.",
  },
  lastNameLabel: {
    id: "funding-application: last name input label",
    defaultMessage: "Last name",
  },
  lastNameError: {
    id: "funding-application: last name required",
    defaultMessage: "Enter your last name.",
  },
  dateOfBirthLabel: {
    id: "funding-application: date of birth label",
    defaultMessage: "Date of birth",
  },
  dateOfBirthError: {
    id: "funding-application: date of birth required",
    defaultMessage: "Enter your date of birth.",
  },
  dateOfBirthInvalidError: {
    id: "funding-application: date of birth invalid",
    defaultMessage: "Enter a valid date.",
  },
  ssnLabel: {
    id: "funding-application: ssn input label",
    defaultMessage: "Social Security Number (SSN)",
  },
  ssnError: {
    id: "funding-application: ssn required",
    defaultMessage: "Enter your Social Security Number.",
  },
  ssnFormatError: {
    id: "funding-application: ssn format error",
    defaultMessage: "SSN format must be 9 digits XXX-XX-XXXX.",
  },
  noSsnLabel: {
    id: "funding-application: no ssn checkbox label",
    defaultMessage: "I do not have a SSN",
  },
  ssnHelperText: {
    id: "funding-application: cleared ssn helper text",
    defaultMessage: "For your security, we've cleared your SSN. Please re-enter to continue.",
  },
  addressLabel: {
    id: "funding-application: address label",
    defaultMessage: "Residential address",
  },
  agreeAndContinueText: {
    id: "funding-application: agree and continue text",
    defaultMessage:
      "By clicking the \u201CI agree and continue\u201D button, you provide written instructions to Wayflyer under the Fair Credit Reporting Act authorizing us to obtain information from your personal credit report and other data from Experian. This information will be used solely to evaluate the company\u2019s eligibility for business financing. <link>View details</link>",
  },
  creditInfoText: {
    id: "funding-application: us credit info text",
    defaultMessage:
      "As you're based in the US, we'll run a soft credit check to build your offer. This won't affect your credit score. Please provide the Social Security Number (SSN) of an authorised officer in your business. It helps us make a faster decision and a better offer.",
  },
  noSsnModalTitle: {
    id: "funding-application: no ssn modal title",
    defaultMessage: "Are you sure you don't have a Social Security Number?",
  },
  noSsnModalContent: {
    id: "funding-application: no ssn modal content",
    defaultMessage:
      "If you have a Social Security Number, we'll need it to process your application. Skipping this step means we'll request it later, which will delay your application.",
  },
  addSsnButton: {
    id: "funding-application: add ssn button",
    defaultMessage: "Add Social Security Number",
  },
  submitWithoutSsnButton: {
    id: "funding-application: submit without ssn button",
    defaultMessage: "Continue without",
  },
  agreeAndSubmitButton: {
    id: "funding-application: agree and submit",
    defaultMessage: "Agree and submit",
  },
});
